import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AppBar, Box, Toolbar, Tooltip, Typography, Avatar } from '@mui/material';
import { Navigation } from './navigation';
import { selectAuth } from '@store/selectors';

export const AppShell: React.FC = () => {
  const { user } = useSelector(selectAuth);
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        bgcolor: 'background.default',
      }}
    >
      <AppBar
        position="fixed"
        elevation={0}
        sx={(theme) => ({
          bgcolor: 'background.default',
          borderBottom: `1px solid ${theme.palette.divider}`,
          zIndex: theme.zIndex.drawer + 1,
        })}
      >
        <Toolbar sx={{ gap: 2 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: '#39C88A',
              letterSpacing: '-0.5px',
              flexGrow: 1,
            }}
          >
            Partner Portal
          </Typography>
          {user?.name && (
            <Tooltip title="My profile" placement="bottom-end">
              <Box
                onClick={() => navigate('/profile')}
                sx={(theme) => ({
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  cursor: 'pointer',
                  borderRadius: '20px',
                  px: 1,
                  py: 0.5,
                  '&:hover': { background: theme.palette.action.hover },
                })}
              >
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  {user.name.givenName} {user.name.familyName}
                </Typography>
                <Avatar
                  sx={{
                    width: 32,
                    height: 32,
                    background: '#39C88A',
                    fontSize: '0.75rem',
                    fontWeight: 700,
                  }}
                >
                  {user.name.givenName?.charAt(0)?.toUpperCase()}
                </Avatar>
              </Box>
            </Tooltip>
          )}
        </Toolbar>
      </AppBar>

      <Box sx={{ display: 'flex', flex: 1, pt: '64px' }}>
        <Navigation />
        <Box
          component="main"
          sx={{
            flex: 1,
            overflow: 'auto',
            p: 3,
            bgcolor: 'background.default',
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};
